import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { AuthProvider } from "./auth/OAuthContext";
import "@fontsource/manrope/latin-400.css";
import "@fontsource/manrope/latin-500.css";
import "@fontsource/manrope/latin-600.css";
import "@fontsource/manrope/latin-700.css";
import "@fontsource/manrope/latin-800.css";
import "@fontsource/rethink-sans/latin-600.css";
import "@fontsource/rethink-sans/latin-700.css";
import "@fontsource/rethink-sans/latin-800.css";
import "./styles.css";

function syncZoomViewport() {
  if (typeof window === "undefined") return;
  const width = window.innerWidth;
  let scale = 1;
  if (width >= 1440) scale = 0.8;
  else if (width >= 1200) scale = 0.85;
  else if (width >= 992) scale = 0.9;
  else if (width >= 768) scale = 0.95;

  document.documentElement.style.setProperty("--zoom-scale", String(scale));
  document.documentElement.style.setProperty("--zoomed-viewport-height", `${window.innerHeight / scale}px`);
}

syncZoomViewport();
window.addEventListener("resize", syncZoomViewport);

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element");

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
